import AdBanner from './AdBanner';

/**
 * InFeedAd - Ad component designed to be inserted between feed items
 * 
 * Matches the dark Inker theme and blends naturally with content cards.
 * Insert every N items in a feed list.
 */

const InFeedAd = ({ slot, className = '' }) => {
    return (
        <div
            className={`relative group ${className}`}
            data-testid="in-feed-ad"
        >
            <div className="bg-zinc-900/30 border border-zinc-800/50 rounded-lg overflow-hidden">
                {/* "Ad" label */}
                <div className="flex items-center gap-2 px-4 pt-3 pb-1">
                    <span className="text-[10px] text-zinc-600 uppercase tracking-widest font-medium">
                        Patrocinado
                    </span>
                    <div className="flex-1 h-px bg-zinc-800/50" />
                </div>

                {/* Ad content */}
                <div className="px-4 pb-3">
                    <AdBanner
                        slot={slot}
                        format="horizontal"
                        className="!my-0 !border-0 !bg-transparent"
                    />
                </div>
            </div>
        </div>
    );
};

export default InFeedAd;
